import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "../../Student/Assests/Scss/LoPerformanceReport.scss";
import Loading from "../../Student/Reusablecomponents/Loading";
import axios from "axios";
import {  useNavigate } from "react-router-dom";
// Below is for import images
import OnTrack from "../../Student/Assests/Images/OnTrack.png";
import Excelling from "../../Student/Assests/Images/Excelling.png";
import NeedsSupport from "../../Student/Assests/Images/NeedsSupport.png";
import ViewAnswers from "../../Student/Assests/Images/ViewAnswers.png";
// Below is for import Components
import SubjectPerformance from "../../Student/Reusablecomponents/SubjectPerformance";
import Speedometer from "../../Student/PerformanceReport/Speedometer";
import PieChart from "../../Student/PerformanceReport/PieChart";
import InternetChecking from "../../Student/Reusablecomponents/Network";
// Below is for import the icons
import { FaGreaterThan, FaLessThan } from "react-icons/fa6";
import { AssessmentName ,CAssessmentName} from "../../Student/Reusablecomponents/RegularFunctions";
import { SubjectIds } from "../../ReusableComponents/CommonFunctions";

import { FaRegUser } from "react-icons/fa";
import { FaRegIdBadge } from "react-icons/fa";
import { MdOutlineGrade } from "react-icons/md";
import { FaVideo } from "react-icons/fa";
import { RiFileExcel2Fill } from "react-icons/ri";
import { PiSpeakerSimpleHighFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import ReuseTable from "../../ReusableComponents/Table";
import { ExportXlButton } from "../../ReusableComponents/CommonComponents";
import { DownloadExcel } from "../../ReusableComponents/CommonFunctions";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { useTranslation } from "react-i18next";
const HQLoPerformanceReport = () => {
  const navigate = useNavigate();
   const { t } = useTranslation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const TeacherStudent = JSON.parse(localStorage.getItem("T2S"));
  const QBTS = JSON.parse(localStorage.getItem("StudentRemidation"));
const HQNDetails = JSON.parse(localStorage.getItem("HQNVLO"));

  const [POverall, setPOverall] = useState();
  const [AssessmentsSummary, SetAssessmentsSummary] = useState();
  const [SubjectwisePerformance, SetSubjectwisePerformance] = useState();
  const [CumulativeReport, SetCumulativeReport] = useState([]);
  const [QDifficulty, SetQDifficulty] = useState();
  const [DecideSub, SetDecideSub] = useState(QBTS?.SubjectName);
  const [Load, SetLoad] = useState(false);

  const [SubjectLos, SetSubjectLos] = useState({
    Strengths: [],
    Improvements: [],
  });

  const fetchAssessmentsSummary = async (e) => {
    SetAssessmentsSummary();
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/StudentResults/GetStudentAssessmentwiseSummary?ContestCreationId=${
            e || TeacherStudent?.CCID
          }&UserId=${
            TeacherStudent?.Studentid || items?.userId
          }&AssessmentType=${TeacherStudent?.TesType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data.noOfQuestions) {
          SetAssessmentsSummary(res.data);
        } else {
          SetAssessmentsSummary(process.env.REACT_APP_NODATAFOUND);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchSubjectwisePerformance = async (e) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/StudentResults/GetStudentSubjectwisePerformance?ContestCreationId=${
            e || TeacherStudent?.CCID
          }&UserId=${
            TeacherStudent?.Studentid || items?.userId
          }&AssessmentType=${TeacherStudent?.TesType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data !== "") {
          SetSubjectwisePerformance(res.data);
          SetDecideSub(QBTS?.SubjectName || res.data[0]?.subjectName);
          setPOverall(
            (res.data?.[0]?.overallPercentage +
              res.data?.[1]?.overallPercentage +
              res.data?.[2]?.overallPercentage) /
              3
          );
          fetchLOCumulativeReport(
            QBTS?.SubjectName || res.data[0]?.subjectName
          );
        } else {
          SetSubjectwisePerformance();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchLOCumulativeReport = async (SUbName) => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/StudentResults/GetSubjectWiseLOPerformance?SubjectName=${SUbName}&ContestCreationId=${
            TeacherStudent?.CCID
          }&UserId=${TeacherStudent?.Studentid || items?.userId}&Type=${
            TeacherStudent?.TesType
          }&LanguageId=${
            items?.mediumId || TeacherStudent?.mediumOfInstruction
          }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetLoad((prev) => !prev);
        SetCumulativeReport(res.data);
        const strengths = [];
        const improvements = [];

        res.data.forEach((item) => {
          if (item.status !== "Improvement") {
            strengths.push(item);
          } else {
            improvements.push(item);
          }
        });

        SetSubjectLos((prev) => ({
          ...prev,
          Strengths: strengths,
          Improvements: improvements,
        }));
      })
      .catch((err) => {
        console.log(err);
        SetLoad((prev) => !prev);
      });
  };

  const fetchQuestionDifficulty = async (e) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/StudentResults/GetStudentAssessmentPerformanceByDL?ContestCreationId=${
            e || TeacherStudent?.CCID
          }&UserId=${
            TeacherStudent?.Studentid || items?.userId
          }&AssessmentType=${TeacherStudent?.TesType}&LanguageId=${
            items?.mediumId || TeacherStudent?.mediumOfInstruction
          }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetQDifficulty(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    CallALLAPIS();
  
  }, []);

  const GotoNextSUbject = () => {
    const index = SubjectwisePerformance.findIndex(
      (sub) => sub.subjectName === DecideSub
    );
    if (index !== -1 && index < SubjectwisePerformance?.length - 1) {
      SetDecideSub(SubjectwisePerformance[index + 1]?.subjectName);
      fetchLOCumulativeReport(SubjectwisePerformance[index + 1]?.subjectName);
    }
  };
 
  const GotoPreviousSUbject = () => {
    const index = SubjectwisePerformance.findIndex(
      (sub) => sub.subjectName === DecideSub
    );
    if (index > 0) {
      SetDecideSub(SubjectwisePerformance[index - 1]?.subjectName);
      fetchLOCumulativeReport(SubjectwisePerformance[index - 1]?.subjectName);
    }
  };

  const HandelSubject = (Subject) => {
    SetDecideSub(Subject);
    fetchLOCumulativeReport(Subject);
  };

  const NavigateRamidation = (
    Subject,
    GradeName,
    ChapterName,
    LovId,
    loName,
    LisTables
  ) => {
    const Params = {
      SubjectName: Subject,
      loName: loName,
      SubId: SubjectIds(Subject),
      Grade: GradeName,
      Chapter: ChapterName,
      LovId: LovId,
      UserType: 12,
      RTables: LisTables,
    };

    localStorage.setItem("StudentRemidation", JSON.stringify(Params));
    navigate(`/LoPerformanceReport/Remediation`);
  };

  const GetScore = (e) => {
    switch (true) {
      case e <= 40:
        return [NeedsSupport, "Needs support", "#FF2A2A"];
      case e >= 41 && e <= 80:
        return [OnTrack, "On track", "#F39C12"];
      case e > 80:
        return [Excelling, "Excelling", "#20CD50"];
      default:
        return "";
    }
  };

  const CallALLAPIS = (e) => {
    fetchSubjectwisePerformance(e);
    fetchAssessmentsSummary(e);
    fetchQuestionDifficulty(e);
  };

  const Navigatetoviewanswersheet = (sub) => {
    localStorage.setItem("subName", sub);
    navigate("/Performance/ViewAnswerSheetDetails/ViewAnswerSheet", {
      state: {
        CCID: TeacherStudent?.CCID,
        TType: TeacherStudent?.TesType,
        Grade: TeacherStudent?.Grade,
        Subjects: TeacherStudent?.Subjects,
      },
    });
  };
 
  const QDcolumns = [
    { name: "Difficulty level", selector: "difficultyLevel" },
    { name: "No of Questions", selector: "noOfQuestions" },
    { name: "No of Correct Answers", selector: "noOfCorrectAnswers" },
    {
      name: "Average % Achievement",
      cell: (row) => <>{row.answeredPercent}%</>,
    },
  ];
  const Strengthscolumns = [
    {
      name: "Strength",
      selector: "loName",
      cell: (row) => (
        <>
          <div style={{ textAlign: "justify" }}>{row.loName}</div>
        </>
      ),
    },
    {
      name: "Remediation",
      cell: (row) => (
        <>
          <div
            className="CPointer gap-1 dflex" >
            <FaVideo
              style={{ color: row.isVideoExists ? "#025f9e" : "#808080" }}
              title={
                !row.isVideoExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isVideoExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["Video"]
                  );
                }
              }}
            />
            |
            <RiFileExcel2Fill
              style={{ color: row.isFileExists ? "Black" : "#808080" }}
              title={
                !row.isFileExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isFileExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["WExamples", "Flashcards", "CSheets"]
                  );
                }
              }}
            />{" "}
            |
            <PiSpeakerSimpleHighFill
              style={{ color: row.isAudioExists ? "Black" : "#808080" }}
              title={
                !row.isAudioExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isAudioExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["Audio"]
                  );
                }
              }}
            />
          </div>
        </>
      ),
    },
  ];

  const AreaImpcolumns = [
    {
      name: "Areas of Improvement",
      selector: "loName",
      cell: (row) => (
        <>
          <div style={{ textAlign: "justify" }}>{row.loName}</div>
        </>
      ),
    },
    {
      name: "Remediation",
      cell: (row) => (
        <>
          <div
            className="CPointer gap-1 dflex" >
            <FaVideo
              style={{ color: row.isVideoExists ? "#025f9e" : "#808080" }}
              title={
                !row.isVideoExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isVideoExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["Video"]
                  );
                }
              }}
            />
            |
            <RiFileExcel2Fill
              style={{ color: row.isFileExists ? "Black" : "#808080" }}
              title={
                !row.isFileExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isFileExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["WExamples", "Flashcards", "CSheets"]
                  );
                }
              }}
            />{" "}
            |
            <PiSpeakerSimpleHighFill
              style={{ color: row.isAudioExists ? "Black" : "#808080" }}
              title={
                !row.isAudioExists ? "Content will show up here shortly." : ""
              }
              onClick={() => {
                if (!row.isAudioExists) {
                  notify("File not available", "error");
                } else {
                  NavigateRamidation(
                    row.subjectName,
                    row.grade,
                    row.chapter,
                    row.loLovId,
                    row.loName,
                    ["Audio"]
                  );
                }
              }}
            />
          </div>
        </>
      ),
    },
  ];

  const DownloadPQDifficult = () => {
    const XL = QDifficulty?.map((item, index) => {
      return {
        SNo: index + 1,
        "Difficulty level": item.difficultyLevel,
        "No of Questions": item.noOfQuestions,
        "No of Correct Answers": item.noOfCorrectAnswers,
        "Average % Achievement": `${item.answeredPercent}%`,
      };
    });
   
    DownloadExcel(
      XL,
      "Performance across Question Difficulty",
      false,
      "Performance across Question Difficulty",
      `${t("Analyze my Strengths.Performance across Question Difficult")}`,
      true
    );
  };
  return (
    <>
      <div
        className={`SPR-MAindiv ${
          TeacherStudent ? " TeacherBgImage mb-2" : "Instructions-pages "
        }`}
      >
        <InternetChecking />
        <div className="container-fluid">
           {HQNDetails ? 
  <b> <span >{HQNDetails?.Region?.RegionName ? <><span className="CPointer " onClick={() => navigate(-4)} style={{ color: "#696969" }}>{HQNDetails?.Region?.RegionName}</span> {""} &gt; {""} </> : ""}</span>
            <span className="CPointer " onClick={() => navigate(-3)} style={{ color: "#696969" }}>{HQNDetails?.State?.StateName || items?.societyName}</span> {""} &gt; {""}
            <span className="CPointer " onClick={() => navigate(-2)} style={{ color: "#696969" }}>{HQNDetails?.District?.DistrictName}</span>{""} &gt; {""}
            <span className="CPointer " style={{ color: "#696969" }}  onClick={() => navigate(-1)}>{HQNDetails?.School?.SchoolName}</span>
          </b>:""}
          <div className="dflex flexd-column  w-100 mb-1">
            {AssessmentsSummary?.noOfQuestions && (
              <p>
                {" "}
                {CAssessmentName(TeacherStudent?.TesType)} -{" "}
                {AssessmentsSummary?.paperCode}{" "}
              </p>
            )}
         
          </div>
          {TeacherStudent && AssessmentsSummary?.noOfQuestions && (
            <div className="TeacherStudentDetails mb-3">
              <span>
                <FaRegUser /> <b>Student name :</b> {TeacherStudent.StudentName}{" "}
              </span>{" "}
              |
              <span>
                <FaRegIdBadge /> <b> Student id :</b>{" "}
                {TeacherStudent.StudentRollno}{" "}
              </span>{" "}
              |
              <span>
                <MdOutlineGrade /> <b> Grade :</b> {TeacherStudent.Grade}{" "}
              </span>
            </div>
          )}
          {AssessmentsSummary?.noOfQuestions ? (
            <>
              <Row>
                <Col md="3">
                  <div className="AssessementSummary">
                    <span>
                      <WithTranslate
                        name="Analyze my Strengths.Total Questions:"
                        Medium={TeacherStudent?.MediumName}
                      />
                    </span>
                    <span>:</span>
                    <span>{AssessmentsSummary?.noOfQuestions}</span>
                    <span>
                      <WithTranslate
                        name="Analyze my Strengths.Maximum Credits:"
                        Medium={TeacherStudent?.MediumName}
                      />
                    </span>
                    <span>:</span>
                    <span>{AssessmentsSummary?.weightage}</span>
                    <span>
                      <WithTranslate
                        name="Analyze my Strengths.Obtained Credits:"
                        Medium={TeacherStudent?.MediumName}
                      />
                    </span>
                    <span>:</span>
                    <span>{AssessmentsSummary?.obtainedScore}</span>
                    <span>
                      <WithTranslate
                        name="Analyze my Strengths.Total % achieved:"
                        Medium={TeacherStudent?.MediumName}
                      />
                    </span>
                    <span>:</span>
                    <span>{AssessmentsSummary?.percentage}%</span>
                  </div>
                </Col>
                <Col>
                  <div className="SubjectPerformance dflex">
                    {SubjectwisePerformance?.map((item, index) => (
                      <div
                        className="dflex flexd-column alignitems"
                        key={index}
                      >
                        <SubjectPerformance
                          size={120}
                          color={GetScore(item.percentage)[2]}
                          percentage={item.percentage}
                          data={`${item.obtainedCredits}/${item.totalCredits}`}
                        />
                        <span>{item.subjectName} </span>
                        <span style={{ color: GetScore(item.percentage)[2] }}>
                          {" "}
                          {GetScore(item.percentage)[1]}{" "}
                        </span>
                      </div>
                    ))}
                    <div
                      className="OverallReport dflex flexd-column alignitems"
                      style={{ border: `1px solid ${GetScore(POverall)[2]}` }}
                    >
                      <span>
                        <WithTranslate
                          name="Analyze my Strengths.Overall percentage:"
                          Medium={TeacherStudent?.MediumName}
                        />{" "}
                        {POverall}%
                      </span>
                      <h6>
                        <img
                          src={GetScore(POverall)[0]}
                          alt={GetScore(POverall)[0]}
                        />
                        <span style={{ color: GetScore(POverall)[2] }}>
                          {" "}
                          {GetScore(POverall)[1]}{" "}
                        </span>
                      </h6>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="mb-3">
                <div className="dflex JSBetween alignitems">
                  <p>
                    <WithTranslate
                      name="Analyze my Strengths.Performance across Learning Outcomes:"
                      Medium={TeacherStudent?.MediumName}
                    />
                  </p>
                  <div className="LO-Legends dflex alignitems">
                    <span className="me-2"></span> 0 - 40% - Need Support
                    <span className="ms-3 me-2"></span> 41 - 80% - On track
                    <span className="ms-3 me-2"></span> 81 - 100% - Excelling
                  </div>
                </div>
                <div className="container-fluid Card">
                  <Row>
                    <Col md="12" lg="4">
                      <div className="PALOutcomes-Navigation dflex alignitems">
                        <FaLessThan
                          onClick={GotoPreviousSUbject}
                          style={
                            DecideSub ===
                            SubjectwisePerformance?.[0]?.subjectName
                              ? { color: "white" }
                              : {}
                          }
                        />
                        {SubjectwisePerformance?.map((item, index) => (
                          <span
                            onClick={() => {
                              HandelSubject(item.subjectName);
                            }}
                            style={
                              DecideSub !== item?.subjectName
                                ? { color: "#9E9E9E" }
                                : {}
                            }
                          >
                            {item?.subjectName}
                          </span>
                        ))} 
                        <FaGreaterThan
                          onClick={() => GotoNextSUbject()}
                          style={
                            DecideSub ===
                            SubjectwisePerformance?.[TeacherStudent?.Subjects.split(",")?.length]?.subjectName
                              ? { color: "white" }
                              : {}
                          }
                        />
                      </div>
                      <div className="Speedometer dflex flexd-column alignitems JCCenter">
                        <Speedometer
                          averagePercentage={
                            CumulativeReport[0]?.overallPercentage
                          }
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="subjectReport dflex alignitems">
                        <p
                          className="View-Answers dflex Poppins"
                          onClick={() => {
                            Navigatetoviewanswersheet(DecideSub);
                          }}
                        >
                          <img src={ViewAnswers} alt="View Answer sheet" /> View
                          / Download Answer sheet
                        </p>
                      </div>
                      <div className="Detail-SubReport dflex">
                        <span>
                          <h6 style={{ color: "#00C637" }}>Strengths</h6>
                          <ReuseTable
                            className="STudenTable dflex"
                            data={SubjectLos?.Strengths}
                            columns={Strengthscolumns}
                          />
                        </span>
                        <span>
                          <span>
                            <h6 style={{ color: "#BB4242" }}>
                              {" "}
                              Areas of Improvement:{" "}
                            </h6>
                            <ReuseTable
                              className="STudenTable "
                              data={SubjectLos?.Improvements}
                              columns={AreaImpcolumns}
                            />
                          </span>
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div>
                <p>
                  <WithTranslate
                    name="Analyze my Strengths.Performance across Question Difficult"
                    Medium={TeacherStudent?.MediumName}
                  />
                </p>
                <div className="Card dflex gap-3">
                  <div>
                    <div className="dflex JSBetween">
                      {" "}
                      <div></div>{" "}
                      <ExportXlButton
                        Name="Download Excel"
                        Click={() => DownloadPQDifficult()}
                      />
                    </div>
                    <ReuseTable
                      className="STudenTable dflex"
                      data={QDifficulty}
                      columns={QDcolumns}
                    />
                  </div>
                  <div className="Piechart w-50">
                    {QDifficulty && <PieChart PChart={QDifficulty} />}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="ErrorMessage">
              {" "}
              {!AssessmentsSummary?.noOfQuestions && AssessmentsSummary}
            </div>
          )}
        </div>
      </div>
      {Load && <Loading />}
    </>
  );
};
export default HQLoPerformanceReport;